var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoTeamMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 253,
    height: 241,
    viewBox: "0 0 253 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.679 4.13692C82.6196 -0.743495 43.0372 -3.15793 18.898 21.4192C-5.17023 45.924 0.910706 85.1449 3.42941 119.441C5.69826 150.335 11.2123 181.384 32.3081 204.02C54.0877 227.39 84.7783 241.345 116.679 240.961C148.236 240.581 175.483 223.055 199.047 202.012C224.491 179.291 256.053 174.969 252.763 119.441C248.943 54.9737 215.546 67.5794 190.004 45.9368C167.68 27.0219 145.615 8.28305 116.679 4.13692Z",
    fill: "#F7F3FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95 87.9688C95 70.2956 109.327 55.9688 127 55.9688C144.673 55.9688 159 70.2956 159 87.9688C159 105.642 144.673 119.969 127 119.969C109.327 119.969 95 105.642 95 87.9688ZM67 184.969C65.8954 184.969 65 184.073 65 182.969V167.969C65 150.296 79.3269 135.969 97 135.969H157C174.673 135.969 189 150.296 189 167.969V182.969C189 184.073 188.105 184.969 187 184.969C179.469 184.969 194.745 184.969 67 184.969Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67 182.969V167.969C67 151.4 80.4315 137.969 97 137.969H157C173.569 137.969 187 151.4 187 167.969V182.969M157 87.9688C157 104.537 143.569 117.969 127 117.969C110.431 117.969 97 104.537 97 87.9688C97 71.4002 110.431 57.9688 127 57.9688C143.569 57.9688 157 71.4002 157 87.9688Z",
    stroke: "#9E70FB",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTeamMember);
export default __webpack_public_path__ + "static/media/no-team-member.406a51bb132d5f962de6a92d45af2884.svg";
export { ForwardRef as ReactComponent };